import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import * as React from "react";

import { RenderIf } from "../../common/RenderIf";
import { cn } from "../../lib/utils";
import { Alert, AlertDescription, AlertTitle } from "../ui";

export function FormErrorAlert({
	title,
	description,
	className,
	severity = "error",
	showSeverity = true,
}: {
	title: string;
	description: React.ReactNode;
	className?: string;
	severity?: "error" | "warning";
	showSeverity?: boolean;
}) {
	return (
		<Alert className={cn("flex items-start", className)} variant="formError">
			<ErrorOutlineIcon className="!size-4 !text-current" />

			<div className="px-4">
				<AlertTitle className="text-sm">
					<RenderIf condition={showSeverity}>
						<span className="capitalize">{severity}</span>
						{": "}
					</RenderIf>
					{title}
				</AlertTitle>
				<AlertDescription className="text-xs">{description}</AlertDescription>
			</div>
		</Alert>
	);
}
